export default __webpack_public_path__ + "static/media/smart-city.569869fa.jpg";